import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-copy">
        Copyright © 2026, <Link to="/">Label Binduu Jain Couture</Link>. <a href="#" onClick={(e) => e.preventDefault()}>All rights reserved</a>
      </div>
    </footer>
  );
};

export default Footer;
